import {
  createDocument,
  deleteDocument,
  getDocuments,
  updateDocument,
} from '../services/documents';

interface Company {
  name: string;
  nit: string;
  sap_code: string;
}

export const createCompany = async (company: Company) => {
  const data = await createDocument(company, 'company');

  return data;
};

export const getCompanies = async () => {
  const data = await getDocuments('company');

  return data;
};

export const deleteCompany = async (uuid: string) => {
  deleteDocument(uuid, 'company');
};

export const getCompanyDetail = async (companyUuid: string) => {
  const data = getDocuments(`company/${companyUuid}`);

  return data;
};

export const updateCompany = async (uuid, payload) => {
  const data = await updateDocument(uuid, payload, 'company');

  return data;
};
